module.exports = __webpack_public_path__ + "img/cbf6e81d34dabf9c21277dc9e48g--tsvety-i-floristika-tsvetochnyj-gorshok.jpg";